export enum TermsAndCondtionsType {
  Text = 1,
  URL = 2,
}
